<template>
  <div>
    <Breadcrumb routeName="InvoiceTemplate" toName="添加发票模板" goPathName="发票模板"></Breadcrumb>
    <a-card :bordered="false">
      <a-form-model
        ref="ruleForm"
        :rules="rules"
        :model="ruleForm"
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="模板名称" prop="templateName">
          <a-input style="width:50%;" v-model="ruleForm.templateName" :maxLength="10" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item label="模板类型" prop="templateType">
          <a-select style="width:50%;" v-model="ruleForm.templateType" placeholder="请选择你的模板类型">
            <a-select-option v-for="(item, index) in invoiceTemplateType" :key="index" :value="item.value">
              {{ item.key }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="支持类型" prop="supportType" v-if="ruleForm.templateType != 1">
          <a-checkbox-group v-model="ruleForm.supportType" @change="checked" style="white-space: nowrap;">
            <a-checkbox v-for="(item, index) in invoiceType" :key="index" :value="String(item.value)">
              {{ item.key }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item label="适用商品" prop="designatedType">
          <a-select v-model="ruleForm.designatedType" style="width: 120px;" placeholder="请选择">
            <a-select-option :value="1">
              指定品类
            </a-select-option>
            <a-select-option :value="2">
              指定商品
            </a-select-option>
          </a-select>
          <a-form-model-item v-if="ruleForm.designatedType == 1" prop="designatedContent">
            <a-checkbox-group v-model="ruleForm.designatedContent">
              <a-checkbox v-for="(ite, index) in proCatalogEnum" :key="index" :value="String(ite.value)">
                {{ ite.key }}
              </a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
          <span style="margin-left: 5%;" v-if="ruleForm.designatedType == 2">
            <a-button type="primary" @click="visible = true">请选择 </a-button>
          </span>
        </a-form-model-item>
        <a-form-model-item v-if="ruleForm.designatedType == 2" :wrapper-col="currentFormLayout.offsetCol">
          <a-table style="width:60%" ref="table1" :columns="columns" :dataSource="productList" rowKey="proId">
            <span slot="proName" slot-scope="index">
              <ellipsis :length="30" tooltip>{{ index }}</ellipsis>
            </span>
            <span slot="action" slot-scope="text, record">
              <a-button type="primary" size="small" @click="deleteProId(record.proId)">移除</a-button>
            </span>
          </a-table>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="onSubmit">提交</a-button>
          <a-button style="margin-left: 3%;" @click="goBack">取消</a-button>
        </a-form-model-item>
      </a-form-model>
      <a-modal title="选择商品" :footer="null" :width="650" :visible="visible" @cancel="visible = false">
        <a-form layout="inline">
          <a-form-item label="商品名称">
            <a-input v-model="queryParams.proName" placeholder="查询商品名称"></a-input>
          </a-form-item>
          <a-form-item label="商品ID">
            <a-input v-model="queryParams.proId" placeholder="查询商品ID"></a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
          </a-form-item>
        </a-form>
        <custom-page-table
          ref="table"
          :queryParams="queryParams"
          :columns="columns"
          base-key="proUrl"
          params-path="public/getGoodsList/"
        >
          >
          <span slot="action" slot-scope="rowItem">
            <a-button type="primary" size="small" @click="selectProId(rowItem.record)">添加</a-button>
          </span>
        </custom-page-table>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'

export default {
  name: 'AddInvoiceTemplate',
  components: {
    Breadcrumb
  },
  data() {
    return {
      currentFormLayout: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 4 },
          lg: { span: 4 },
          sm: { span: 6 },
          md: { span: 9 },
          xs: { span: 11 }
        },
        wrapperCol: {
          xxl: { span: 21 }, //≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 20 }, //≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 20 }, //≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 18 }, //≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 15 }, //≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 13 } //xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 3 },
          xl: { offset: 4 },
          lg: { offset: 4 },
          sm: { offset: 6 },
          md: { offset: 9 },
          xs: { offset: 11 }
        }
      },
      queryParams: {
        shopProSource: 0
      },
      id: this.$route.query.id,
      columns: [
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      visible: false,
      invoiceType: [],
      invoiceTemplateType: [],
      proCatalogEnum: [],
      selected: undefined,
      ruleForm: {},
      productList: [],
      rules: {
        templateName: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        templateType: [{ required: true, message: '请选择你的模板类型', trigger: 'blur' }],
        supportType: [
          {
            required: true,
            message: '请选择发票支持类型',
            trigger: 'blur'
          }
        ],
        designatedContent: [{ required: true, message: '请选择商品品类', trigger: 'change' }],
        designatedType: [{ required: true, message: '请选择适用商品', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.getInvoiceType()
    this.getInvoiceTemplateType()
    this.getProCatalogEnum()
    this.detailList()
  },
  methods: {
    //数据回显
    detailList() {
      if (this.id) {
        this.getHttpServices()
          .getUserService()
          .post('invoice/v2/templateDetail', { id: this.id })
          .then(res => {
            this.ruleForm = res
            if (res.supportType) {
              this.ruleForm.supportType = res.supportType.split(',')
              this.getLogUtils().logWithTag('this.ruleForm.supportType', this.ruleForm.supportType)
            }
            if (res.supportType == '') {
              this.ruleForm.supportType = undefined
            }
            if (res.designatedType == 1) {
              if (res.designatedContent) {
                this.ruleForm.designatedContent = res.designatedContent.split(',')
                this.getLogUtils().logWithTag('this.designatedContent', this.ruleForm.designatedContent)
              }
            }
            if (res.designatedType == 2) {
              if (res.list.length > 0) {
                this.productList = res.list
                this.getLogUtils().logWithTag('this.productList', this.productList)
              }
            }
          })
          .catch(err => {
            this.$message.error(err.msg)
          })
      }
    },

    //
    getInvoiceType() {
      this.getHttpServices()
        .getUserService()
        .post('invoice/v2/getInvoiceSupportTypeEnum')
        .then(res => {
          this.invoiceType = res
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    //
    getInvoiceTemplateType() {
      this.getHttpServices()
        .getUserService()
        .post('invoice/v2/getInvoiceTemplateTypeEnum')
        .then(res => {
          this.invoiceTemplateType = res
          this.getLogUtils().logWithTag('错误', res)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    //
    getProCatalogEnum() {
      this.getHttpServices()
        .getUserService()
        .post('invoice/v2/getProCatalogEnum')
        .then(res => {
          this.proCatalogEnum = res
        })
        .catch(err => {
        })
    },
    getProductList(params) {
      return this.getHttpServices()
        .getUserService()
        .post('merchant/v2/group/getCommissionGroupList', params)
    },
    //移出商品
    deleteProId(proId) {
      this.getLogUtils().logWithTag('deleteProId', this.productList)
      const productList = [...this.productList]
      this.productList = productList.filter(item => item.proId !== proId)
    },
    //选择商品
    selectProId(obj) {
      if (this.productList.length < 5) {
        if (this.productList.length > 0) {
          let flag = false
          this.productList.map(item => {
            if (item.proId == obj.proId) {
              this.$message.error('请勿重复添加商品')
              flag = true
            }
          })
          if (!flag) {
            this.productList.push(obj)
            this.visible = false
            //this.aaa()
            this.getLogUtils().logWithTag('this.productList', this.productList)
          }
        } else {
          this.productList.push(obj)
          this.visible = false
          //this.aaa()
          this.getLogUtils().logWithTag('this.productList', this.productList)
        }
      } else {
        this.$message.error('最多添加5个商品')
      }
    },
    checked(checkedValues) {
      this.ruleForm.supportType = checkedValues
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = {}
          if (this.ruleForm.designatedType == 1) {
            params.designatedContent = this.ruleForm.designatedContent.join(',')
          }
          if (this.ruleForm.designatedType == 2) {
            if (this.productList.length == 0) {
              this.$message.error('请至少选择一个商品')
              return
            }
            var newArr = []
            for (var i = 0; i < this.productList.length; i++) {
              var vote = {}
              vote.proId = this.productList[i].proId
              vote.proName = this.productList[i].proName
              newArr.push(vote)
            }
            params.list = newArr
            this.getLogUtils().logWithTag('params.list', params.list)
          }
          if (this.ruleForm.supportType) {
            params.supportType = this.ruleForm.supportType.join(',')
          }
          if (this.ruleForm.templateType == 1) {
            params.supportType = ''
          }
          if (this.id) {
            params.id = this.id
          }
          params.designatedType = this.ruleForm.designatedType
          params.templateName = this.ruleForm.templateName
          params.templateType = this.ruleForm.templateType
          this.getHttpServices()
            .getUserService()
            .post('invoice/v2/saveTemplate', params)
            .then(res => {
              this.$message.success('提交成功')
              this.goBack()
            })
            .catch(err => {
              this.$message.error(err.msg)
            })
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    goBack() {
      this.$router.back(-1)
    }
  }
}
</script>
<style scoped>
</style>
